import api from '@pray/shared/utils/api';

import type { UsersData } from './types/analytics';

export type GetExperimentUsersParams = {
  experimentId: string;
  instanceName?: string;
  experimentListNumber: number;
  variation?: string;
  page?: number;
  pageSize?: number;
};

export type GetExperimentUsersResponse = {
  data: UsersData;
};

/**
 * Fetches users in an experiment with optional variation filter.
 * Returns paginated list with links to Amplitude profiles.
 */
export async function getExperimentUsers({
  experimentId,
  instanceName,
  experimentListNumber,
  variation,
  page = 1,
  pageSize = 50,
}: GetExperimentUsersParams): Promise<UsersData> {
  if (!experimentId) throw new Error('Experiment ID is required');

  const url = `/web/studio/experiments/${experimentId}/analytics/users`;
  const params: Record<string, string | number> = {
    experiment_list_number: experimentListNumber,
    page,
    page_size: pageSize,
  };

  if (instanceName) {
    params.instance_name = instanceName;
  }

  if (variation) {
    params.variation = variation;
  }

  const response = await api.executeGetRequest<GetExperimentUsersResponse>(url, params);

  return response.data.data;
}
